export default __webpack_public_path__ + "static/gear-8e423270dffaae47675e5993a71b54f3.jpg";